import { Injectable, EventEmitter, Output, Directive } from '@angular/core';

import { Router } from '@angular/router';

@Directive()
@Injectable()
export class CalendarService {

  public targetDate: Date;
  public numberOfRecordsInFilter: number;
  @Output() numberOfRecordsChanged: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router
  ) { }

  public redirectToDate(targetDate: Date) {
    var urlDate =  targetDate.getMonth() + 1 + "-" + targetDate.getDate() + "-" + targetDate.getFullYear();
    console.log(urlDate);

    var url = "calendar-date";
      
    this.router.navigate([url, urlDate]);
  }

}
